import { Controller } from "@hotwired/stimulus"

// Keeps the operator pane in sync with the public chat loaded in the iframe.
export default class extends Controller {
  static targets = ["iframe", "operatorFrame"]
  static values = {
    chatPathTemplate: String,
    pollInterval: { type: Number, default: 800 }
  }

  connect () {
    this.lastChatId = null
    this.timer = setInterval(() => this.syncFromIframe(), this.pollIntervalValue)
    this.iframeTarget?.addEventListener("load", () => this.syncFromIframe())
  }

  disconnect () {
    if (this.timer) clearInterval(this.timer)
  }

  syncFromIframe () {
    if (!this.hasIframeTarget || !this.hasOperatorFrameTarget) return

    let pathname
    try {
      pathname = this.iframeTarget.contentWindow?.location?.pathname
    } catch (_error) {
      return
    }
    if (!pathname) return

    const match = pathname.match(/\/chats\/(\d+)\/?$/)
    if (!match) return

    const chatId = match[1]
    if (chatId === this.lastChatId) return

    this.lastChatId = chatId
    this.operatorFrameTarget.src = this.chatPathTemplateValue.replace("__CHAT_ID__", chatId)
  }
}
